
































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';

import ShiftVDPFactForm from './ShiftVDPFactForm/ShiftVDPFactForm.vue'
import ShiftVDPFactPrint from './ShiftVDPFactPrint/ShiftVDPFactPrint.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedFactsList', 'meta'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
      'remainsById', 'totals', 'rotateFacts'
    ]),
  },
  components: {
    ShiftVDPFactForm
  }
})
export default class ShiftVDPFact extends Vue {

  @Prop() documentId!: string;

  opened: any[] = [];
  public dropFiles = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  sortByNumber(a: any, b: any, isArc: boolean) {
    console.log(a, b, isArc)
    const keyA = parseFloat(a.number);
    const keyB = parseFloat(b.number);
    const result = (keyA > keyB) ? 1 : ((keyA < keyB) ? -1 : 0)
    return result * (isArc ? 1 : -1)
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftVDPFactForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        documentId: this.documentId,
        volumeType: row.volume_type,
        initParams: {
          shift_plan_id: row.plan_id
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  openPrintDocument(row: any) {
    this.$buefy.modal.open({
      component: ShiftVDPFactPrint,
      props: {
        factId: row.id,
        labelText: row.label_text,
        volumeType: row.volume_type
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public exportAsXLSX() {
    this.$store.dispatch(`${STORE_KEY}/exportAsXLSX`, {
      documentId: this.documentId,
    });
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
    });
  }

  public copyPlan(row: any) {
    this.$buefy.dialog.prompt({
      message: `Сколько ведер отделить?`,
      inputAttrs: {
          type: 'number',
          step: "any",
          placeholder: 'Количество',
          min: 0,
          max: row.quantity,
      },
      confirmText: 'Раделить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/copyPlan`, {
          planId: row.plan_id,
          shiftId: this.documentId,
          number: row.number,
          value: parseInt(value),
        }).then(() => {
        this.$buefy.snackbar.open(`Запись успешно разделена`);
          this.handleParamsChange()
        })
      }
    })
  }

  setExctartTime(row: any, extract_time: any) {
    row.finalized = false;
    this.$store.dispatch(`${STORE_KEY}/setExctartTime`, {
      documentId: this.documentId,
      row,
      extract_time
    })
  }
}

